import React, { useState } from 'react';
import classNames from 'classnames';
import { Button, Modal } from 'react-bootstrap';
import WarningTriangle from '../../../assets/images/warning-triangle.svg';

import './NotificationPopupModal.scss';

const NotificationPopupModal = (props) => {
	const {
		customChildComponent,
		title,
		bodyText,
		size = 'md',
		confirmLabel = 'OK',
		confirmReverseColor = false,
		cancelLabel = 'CLOSE',
		onClose = () => {},
		onConfirm,
		light = false,
		backdrop = true,
		warning = false
	} = props;

	const [show, setShow] = useState(true);

	const _onClose = () => {
		setShow(false)
		onClose();
	}

	const cancelButton = (
		<Button
			onClick={_onClose}
			variant={`outline-${confirmReverseColor ? 'light' : 'primary'}`}
			className={`common-font custom-button ${confirmReverseColor ? 'confirm' : 'close'}-button`}
		>
			{cancelLabel}
		</Button>
	);

	const confirmButton = (
		<Button
			onClick={onConfirm}
			variant={`outline-${confirmReverseColor ? 'primary' : 'light'}`}
			className={`common-font custom-button ${confirmReverseColor ? 'close' : 'confirm'}-button`}
		>
			{confirmLabel}
		</Button>
	);

	return (
		<Modal
			size={size}
			key="notification-popup-modal-key"
			show={show}
			aria-labelledby="contained-modal-title-vcenter"
			centered
			scrollable={false}
			className="notification-popup-modal"
			onHide={_onClose}
			backdropClassName="notification-popup-modal-backdrop"
			backdrop={backdrop}
		>
			<Modal.Header closeButton={!!light} />
			<Modal.Body>
				{warning && <img className="notification-popup-modal-image" src={WarningTriangle} alt="Warning badge" />}
				<div className="notification-popup-modal-title">
					<div className="common-font title-font">{title}</div>
				</div>
				<div className="common-font notification-popup-modal-body">
					{ }
					{customChildComponent || (
						<div
							className={classNames({ 'body-text': !light, 'body-text-light': light })}
							dangerouslySetInnerHTML={{ __html: bodyText }}
						/>
					)}
				</div>
				{!light && (
					<div className="notification-popup-modal-footer">
						<div className="buttons-block">
							{cancelButton}
							<div className="mx-3" />
							{confirmButton}
						</div>
					</div>
				)}
			</Modal.Body>
		</Modal>
	);
};

export default NotificationPopupModal;
